import BrushMapPage from '@/pages/BrushMapPage/BrushMapPage.vue'

export default BrushMapPage
